import { render, staticRenderFns } from "./VerificationView.vue?vue&type=template&id=27f2725e&scoped=true&"
import script from "./VerificationView.vue?vue&type=script&lang=js&"
export * from "./VerificationView.vue?vue&type=script&lang=js&"
import style0 from "./VerificationView.vue?vue&type=style&index=0&id=27f2725e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2725e",
  null
  
)

export default component.exports